import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

interface MarkdownRendererProps {
  content: string;
  className?: string;
  size?: 'sm' | 'default' | 'lg';
}

export function MarkdownRenderer({ 
  content, 
  className,
  size = 'default' 
}: MarkdownRendererProps) {
  return (
    <div
      className={cn(
        'prose prose-slate dark:prose-invert max-w-none break-words overflow-x-auto',
        '[overflow-wrap:anywhere]',
        // Custom styling to match the design system
        'prose-headings:text-foreground prose-headings:font-semibold',
        'prose-p:text-muted-foreground prose-p:leading-relaxed',
        'prose-a:text-primary prose-a:no-underline hover:prose-a:underline',
        'prose-strong:text-foreground prose-strong:font-semibold',
        'prose-code:text-foreground prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-sm prose-code:before:content-none prose-code:after:content-none',
        'prose-pre:bg-muted prose-pre:border prose-pre:border-border prose-pre:overflow-x-auto',
        'prose-ul:text-muted-foreground prose-ol:text-muted-foreground',
        'prose-li:marker:text-muted-foreground',
        'prose-blockquote:border-l-primary prose-blockquote:text-muted-foreground',
        'prose-hr:border-border',
        'prose-table:text-sm prose-th:text-foreground prose-td:text-muted-foreground',
        size === 'sm' && 'prose-sm',
        size === 'lg' && 'prose-lg',
        className
      )}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Ensure external links open in new tab with security attributes
          a: ({ node, ...props }) => (
            <a 
              {...props} 
              target="_blank" 
              rel="noopener noreferrer"
            />
          ),
          // Disable images from markdown for security (only seller-uploaded images allowed)
          img: () => null,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
